module.exports = {
  components: {
    '@/views/dashboard/content/asset-upload':
      '@/views/dashboard/content/upload-files/upload-with-desc',
    '@/views/dashboard/content/project': '@/views/dashboard/content/upload-files/upload-with-desc',
    '@/views/dashboard/content/update-file':
      '@/views/dashboard/content/upload-files/update-with-desc',
  },
  navbarLogoImageName: 'xgd-logo.png',
  logoImageName: 'xgd_login_logo.png',
  loginBigTitle: '',
  loginPageBackgroundImg: '',
  blockBrowserText: '区块链浏览器',
  fileVerifyCenterText: '文件验证中心',
  corporationCompany: '',
  serviceSystem: '',
  usernameAvailableWhenSignup: false,
  projectIdIsStringType: true,
  needGetUserNameFromAPIInHome: true,
  needEnterpriseAuth: true,
  modifyUserNameAvaliable: false,
  enterpriseChainCommitmentVisible: true,
  signContentVisible: false,
  fileSaveInCourtVisible: true,
  frontPageAvailable: false,
  frontPageVersion: 'default',
  assetConsumeCredit: 200,
  vaultConsumeCredit: 1000,
  signCertificateVisible: false,
  needRealPersonAndCompanyAuth: true,
  realAuthNeedOCR: false,
  proofKeyNewVersion: false,
  asyncGenerateProof: true,
  uploadFileDescriptionAvailable: false,
  apiContainBigint: true,
  defaultPage: 'home',
  tableSize: 'middle',
  dashboard: {
    sidebar: {
      chartVisible: false,
      disclosureAvailable: true,
      applicationVisible: true,
      copyrightVisible: true,
      creditVisible: true,
      chatgptAvailable: true,
    },
  },
  bgImageInReviewVisible: false,
  baseAPI: 'https://api.xgd.szzcbx.com',
  verifyBaseAPI: 'https://api.auth.hndip.cn',
  enterpriseApplyFileURL:
    'https://xgd.szzcbx.com/%E8%AE%A4%E8%AF%81%E7%94%B3%E8%AF%B7%E8%A1%A8.docx',
  chainBrowserURL: 'https://www.yuanbenlian.com',
  chainBrowserHome: '/blocklist/',
  webTitle: '西工大科技园数字资产保险创新中心',
  statisticsBaseAPI: 'https://api.stat.hndip.cn',
  supportEmail: 'support@yuanben.org',
  allowPhoneLogin: true,
  allowUserNameLogin: false,
  allowRegister: true,
  allowResetPassword: true,
  requirePhoneValidation: true,
  skipPhoneValidation: true,
  requireIntegral: true,
  saasWebsite: '',
  strongPassword: false,
  addMemberAvailable: true,
  multiCompany: true,
};
